import React from "react"
import API from "../../../data/trajectory"
import Util from "../../../util/util"
import "./wordCloud.scss"
const Tabs = [
  { name: "时间", en: "Time", key: "times" },
  { name: "频度", en: "Frequency", key: "count" },
  { name: "综合", en: "Index", key: "weight" },
]
const echarts = window.echarts
var clouds = []

var geo = []
var bgeo = []
var c_data
var ons
class WordCloud extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      cur: 2,
    }
    clouds = []

    geo = []
    bgeo = []
    c_data = []
    ons = {}
  }

  componentDidMount() {
    var dom = this.refs.$map
    this.myChart = echarts.init(dom)
    this.requetGeo()
  }
  requetGeo() {
    let me = this
    let chart = this.myChart
    API.getAoiGeo().then(data => {
      clouds = data
      for (var i = 0; i < clouds.length && i < 60; i++) {
        let cloud = clouds[i]
        if (geo.toString().indexOf(cloud["community"]) === -1) {
          if (cloud["community"] !== "\\N") {
            if (cloud["b_name"] === "\\N") {
              cloud["b_name"] = " "
              cloud["b_type"] = " "
            }
            geo.push(
              '{"name":"' +
                cloud["community"] +
                '","value":' +
                parseInt(parseFloat(cloud["weight"]) * 100) +
                ',"province":"' +
                cloud["p_name"] +
                '","city":"' +
                cloud["c_name"] +
                '","area":"' +
                cloud["d_name"] +
                '","business":"' +
                cloud["b_name"] +
                '","business_type":"' +
                cloud["b_type"] +
                '","tag":"' +
                cloud["tag"] +
                '","lon":' +
                cloud["lon"] +
                ',"lat":' +
                cloud["lat"] +
                ',"sytime":' +
                cloud["sytime"] +
                ',"count":' +
                parseInt(parseFloat(cloud["count"]) * 100) +
                ',"weight":' +
                cloud["weight"] +
                ',"times":' +
                cloud["times"] +
                "}"
            )
          }
        }

        if (bgeo.toString().indexOf(cloud["b_name"]) === -1) {
          if (cloud["b_name"] !== " " && cloud["b_name"] !== "\\N") {
            bgeo.push(
              '{"name":"' +
                cloud["b_name"] +
                '","value":' +
                parseInt(parseFloat(cloud["weight"]) * 100) +
                ',"province":"' +
                cloud["p_name"] +
                '","city":"' +
                cloud["c_name"] +
                '","area":"' +
                cloud["d_name"] +
                '","community":"' +
                cloud["community"] +
                '","business_type":"' +
                cloud["b_type"] +
                '","tag":"' +
                cloud["tag"] +
                '","lon":' +
                cloud["lon"] +
                ',"lat":' +
                cloud["lat"] +
                ',"sytime":' +
                cloud["sytime"] +
                ',"weight":' +
                cloud["weight"] +
                ',"times":' +
                cloud["times"] +
                ',"polygon":' +
                cloud["polygon"] +
                "}"
            )
          }
        }
      }

      var a_c = []
      for (let i = 0; i < clouds.length; i++) {
        var v = clouds[i]
        var c = 1
        var n = v["b_name"]
        var com = v["community"]
        if (n === "\\N" || n === " ") {
          continue
        }
        for (let j = 0; j < clouds.length; j++) {
          var val = clouds[j]

          var n2 = val["b_name"]
          var com2 = val["community"]
          if (n2 === "\\N" || n2 === " ") continue
          if (com !== com2 && n === n2) c += 1
        }
        a_c.push({ name: n, value: c })
      }

      for (let i = 0; i < bgeo.length; i++) {
        var ne = bgeo[i]
        let val = JSON.parse(ne)
        for (var j = 0; j < a_c.length; j++) {
          if (val["name"] === a_c[j]["name"]) {
            bgeo[i] = ne.replace("}", ',"count":' + a_c[j]["value"] * 10 + "}")
          }
        }
      }

      geo = geo.concat(bgeo)

      for (let i = 0; i < geo.length; i++) {
        geo[i] = JSON.parse(geo[i])
      }
      c_data = geo.slice(0)
      ons = {
        tooltip: { show: true },
        series: [
          {
            type: "wordCloud",
            gridSize: 1,
            textPadding: 0,
            sizeRange: [12, 30],
            rotationRange: [-90, 90],
            shape: "diamond",
            width: "100%",
            height: "100%",
            drawOutOfBound: false,
            textStyle: {
              normal: {
                color: function() {
                  return (
                    "rgb(" +
                    [
                      Math.round(Math.random() * 160),
                      Math.round(Math.random() * 160),
                      Math.round(Math.random() * 160),
                    ].join(",") +
                    ")"
                  )
                },
              },
              emphasis: {
                shadowBlur: 10,
                shadowColor: "#333",
              },
            },
            data: geo,
          },
        ],
      }
      chart.setOption(ons)
      chart.on("click", function(params) {
        if (params.componentType === "series") {
          let poi = params.data
          me.props.onClick && me.props.onClick(poi)
        }
      })
      Util.registerChartsResize(chart)
    })
  }
  componentWillUnmount() {
    Util.destroyCharts(this.myChart)
  }
  changeTab = (i, key) => {
    var chart = this.myChart
    if (key === "times") {
      c_data.forEach(d => {
        var t = parseInt(d["times"] * 100)
        if (t === 0) t = parseInt(Math.random() * 5) + 1
        d.value = parseInt(t)
      })
    } else if (key === "count") {
      c_data.forEach(d => {
        d.value = d.count
      })
    } else if (key === "weight") {
      c_data.forEach(d => {
        d.value = d.weight * 100
      })
    }
    var opn = {
      series: [
        {
          data: c_data,
        },
      ],
    }
    chart.setOption(opn)
    this.setState({ cur: i })
  }
  render() {
    let { cur } = this.state
    return (
      <div
        className="panel-word-cloud"
        style={{ height: Util.client.height / 2 }}
      >
        <div className="tabs">
          {Tabs.map((tab, i) => {
            return (
              <div
                key={i}
                className={i === cur ? "active" : ""}
                onClick={() => {
                  this.changeTab(i, tab.key)
                }}
              >
                <span>{tab.name}</span>
                <br />
                <span>{tab.en}</span>
              </div>
            )
          })}
        </div>
        <div className="word-container" ref="$map" />
      </div>
    )
  }
}

export default WordCloud
